import React from "react";

const STATUS_STYLES = {
  en_vigueur: "bg-[#D1FAE5] text-[#065F46] border-[#A7F3D0]",
  modifie: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  abroge: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]",
};

export default function StatusBadge({ status, label }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES.en_vigueur;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-mono font-semibold border uppercase tracking-wider ${cls}`}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </span>
  );
}
